"use client";

import React from 'react';
import { Button } from '@/components/ui/button';
import { Smile } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

// Common emoji shortcuts
const COMMON_EMOJIS = [
  '😀', '😂', '😍', '😢', '😎', '👍', '❤️', '🎉',
  '🔥', '✨', '🚀', '💯', '🙌', '👏', '🤔', '😅'
];

interface EmojiPickerProps {
  onEmojiSelect: (emoji: string) => void;
  disabled?: boolean;
}

const EmojiPicker: React.FC<EmojiPickerProps> = ({ onEmojiSelect, disabled = false }) => {
  return (
    <Popover>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <Button
                type="button"
                variant="outline"
                size="icon"
                className="flex-shrink-0 h-10 w-10 bg-muted hover:bg-primary/20 active:scale-95 transition-all"
                disabled={disabled}
              >
                <Smile className="h-4 w-4 text-foreground" />
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent>
            <p>Agregar emoji</p>
          </TooltipContent>
        </Tooltip>
        <PopoverContent className="w-fit p-1.5 z-[9999]" align="end" side="top">
          <div className="grid grid-cols-7 gap-1.5">
            {COMMON_EMOJIS.map((emoji) => (
              <button
                key={emoji}
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onEmojiSelect(emoji);
                }}
                className="h-9 w-9 flex items-center justify-center text-lg hover:bg-muted/50 rounded transition-all duration-150 hover:scale-110 active:scale-95"
              >
                {emoji}
              </button>
            ))}
          </div>
        </PopoverContent>
      </TooltipProvider>
    </Popover>
  );
};

export default EmojiPicker;
